import { AfterViewInit, Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
//import { NotebookCreateFormConfig } from '../config/notebook-create-form.config';

import { ResourcesInstanceConfig } from "../interfaces/resources-instance-config";

import { NotebookEnvironment } from "../interfaces/notebook-environment";
import { Router } from "@angular/router";
import feather from "feather-icons";
import { NotebookService } from "../services/notebook.service";
import { NotebookCreateRequest } from "../interfaces/notebook-create-request";
import { ConsumptionService } from "../services/consumption.service";
import { Observable, Subject, take, finalize, switchMap, EMPTY, tap, catchError } from "rxjs";
import { UserUsage } from "../interfaces/user-usage";
import {
  DEFAULT_MAX_USER_USAGE,
  START_QUOTA_MESSAGE,
  GATEWAY_ERROR_MESSAGE,
  NOTEBOOK_DEFAULTS,
  STANDARD_CPU_INSTANCES,
  QISKIT_TUTORIALS_FRAMEWORK_ID,
  QISKIT_TUTORIALS_FRAMEWORK_VERSION,
  QISKIT_TUTORIALS_VOLUME,
  ENV_VERSIONS_DOC_LINK,
  TUTORIAL_SELECTION_HINT,
  ENV_VERSIONS_HINT,
  ENV_VERSIONS_HINT_LINK_TEXT
//  NOTEBOOK_ENVIRONMENTS,
} from "../config/notebook-config";
import { SnackbarService } from "../services/snackbar.service";
import { AuthService } from "../../auth/services/auth.service";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
  standalone: true,
    selector: "app-notebook-create-form",
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
         MatTooltipModule,
    ],
    templateUrl: "./notebook-create-form.component.html",
    styleUrls: ["./notebook-create-form.component.css"]
})
export class NotebookCreateFormComponent implements OnInit, AfterViewInit {
  selectEnvOpened = false;
  selectVersionOpened = false;
  readonly maxAllowedUsage = DEFAULT_MAX_USER_USAGE;
   
  readonly maxCpu = NOTEBOOK_DEFAULTS.maxCpu;
  readonly startQuotaMessage = START_QUOTA_MESSAGE;
  readonly gatewayQuotaMessage = GATEWAY_ERROR_MESSAGE;
  readonly envVersionsDocLink = ENV_VERSIONS_DOC_LINK;
  readonly tutorialSelectionHint = TUTORIAL_SELECTION_HINT;
  readonly envVersionsHint = ENV_VERSIONS_HINT;
  readonly envVersionsHintLinkText = ENV_VERSIONS_HINT_LINK_TEXT;

  cpu = NOTEBOOK_DEFAULTS.cpu;
  usage$!: Observable<UserUsage>;
  

  quotaUsed$!: Observable<{
    cpu: { label: string; width: string };
    ram: { label: string; width: string };
    storage: { label: string; width: string };
  }>;

  name = "";
  environment = "";
  version = "";

  environments: NotebookEnvironment[] = [];  
  versions: string[] = [];
  selectOpened = false;
  //startQuotaMessage:string='Available quota exceeded, please stop or delete running Quantum Emulators';

  userId!: string | null;
  private destroy$ = new Subject<void>();

  loadingEnvs = false;
  isSubmitting = false;
  constructor(
    private router: Router,
    private notebookService: NotebookService,
    private consumptionService: ConsumptionService,
    private snackbarService: SnackbarService,
    private authService: AuthService
  ) {
    this.updateVersions();
  }

  //****************************** lifecycle ********************************
  ngOnInit(): void {
    // init usage
    this.consumptionService.initUsage(this.notebookService);
    this.consumptionService.initQuotaMonitoring(this.notebookService);
    this.usage$ = this.consumptionService.getCurrentUsage$();
    this.quotaUsed$ = this.consumptionService.getQuotaUsed$();
    this.initUserId();
    this.loadEnvironments();
  }

  ngAfterViewInit() {
    setTimeout(() => feather.replace(), 0);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.consumptionService.cleanupQuotaMonitoring();
  }

   //****************************** form ********************************
   //Load environments from API and sync versions list
private loadEnvironments(): void {
  this.loadingEnvs = true;

  this.notebookService
    .getNotebookEnvironments()
    .pipe(take(1))
    .subscribe({
      next: (envs) => {
        this.environments = this.filterCpuEnvironments(envs ?? []);

        const defaultEnvironment = this.environments.find(
          (env) =>
            env.frameworkId.trim().toLowerCase() ===
            QISKIT_TUTORIALS_FRAMEWORK_ID.trim().toLowerCase()
        );

        this.environment = defaultEnvironment?.frameworkId ?? "";

        this.updateVersions();
      },

      error: (err) => {
        console.error("Failed to load environments", err);
      },

      complete: () => {
        this.loadingEnvs = false;
      },
    });
}

private filterCpuEnvironments(
  environments: NotebookEnvironment[]
): NotebookEnvironment[] {
  return environments
    .map((env) => ({
      ...env,
      frameworkVersions: this.filterCpuVersions(
        env.frameworkVersions ?? []
      ),
    }))
    .filter((env) => env.frameworkVersions.length > 0);
}

  private filterCpuVersions(versions: string[]): string[] {
  return versions.filter(
    version => version.toLowerCase().endsWith("-cpu")
  );
}

updateVersions(): void {
  const selected = this.environments.find(
    (e) => e.frameworkId === this.environment
  );

  this.versions = selected?.frameworkVersions ?? [];

  const isQiskit =
    this.environment?.trim().toLowerCase() ===
    QISKIT_TUTORIALS_FRAMEWORK_ID.trim().toLowerCase();

  if (
    isQiskit &&
    this.versions.includes(QISKIT_TUTORIALS_FRAMEWORK_VERSION)
  ) {
    this.version = QISKIT_TUTORIALS_FRAMEWORK_VERSION;
  } else {
    this.version = "";
  }
}

  closeForm() {
    this.router.navigateByUrl("/list");
  }

  private initUserId(): void {
    this.userId = this.authService.getUserId();
     console.log("user id from init user id:",this.userId); //!!preferred_username
    if (!this.userId) {
      // this.snackbarService.openSnackBarWithAction('User ID is missing or invalid. Unable to create a Quantum Emulator', '✕', 'error');
      console.error(
        "User ID is missing or invalid. Unable to create a Quantum Emulator"
      );
      return;
    }
  }

  submitForm() {
  if (this.isSubmitting) return;

  const userId = this.authService.getUserId();
  if (!userId) return;
    console.log("user id from submit form: ",userId); //!!preferred_username
  if (!this.name.trim() || !this.environment || !this.version) {
    this.snackbarService.openSnackBarWithAction("Please fill in all required fields", "✕", "error");
    return;
  }


  const requestPayload: NotebookCreateRequest = {
    env: {
      editorId: NOTEBOOK_DEFAULTS.editorId,
      frameworkId: this.environment,
      frameworkVersion: this.version,
    },
    labels: {
      [NOTEBOOK_DEFAULTS.labelKey]: userId,
    },
    name: this.name.trim(),
    resources: {
      cpu: this.cpu,
      flavor: NOTEBOOK_DEFAULTS.flavor,
      gpu: NOTEBOOK_DEFAULTS.gpu,
    },
    unsecureHttp: NOTEBOOK_DEFAULTS.unsecureHttp,
    ...(this.buildNotebookVolumes() && {
      volumes: this.buildNotebookVolumes(),
    }),
  };
 console.log("Notebook create payload:", requestPayload);

    // prevent double-clicks fix
this.isSubmitting = true;
this.consumptionService.loadAndCalculateUsage(this.notebookService);

this.notebookService.createNotebook(requestPayload).pipe(
  tap(() => this.router.navigateByUrl("/list")),
  catchError(err => {
    if (err.status === 402) {
      this.snackbarService.openSnackBarWithAction(this.startQuotaMessage, "✕", "error");
      console.log("GW: CPU limit exceeded. Can't start notebook.");
    } else {
      console.error("Notebook creation failed", err);
      this.snackbarService.openSnackBarWithAction("Creation failed. Please try again.", "✕", "error");
    }
    return EMPTY;
  }),
  finalize(() => { this.isSubmitting = false; })
).subscribe();
  }

  getNotebookSpecs(): ResourcesInstanceConfig {
    return (
      STANDARD_CPU_INSTANCES.find((instance) => instance.cpu === this.cpu) ??
      STANDARD_CPU_INSTANCES[0]
    );
  }

  incrementCPU() {
    if (this.cpu < this.maxCpu) this.cpu++;
  }

  decrementCPU() {
    if (this.cpu > 1) this.cpu--;
  }

  getPublicNetworkDisplay(): string {
    const value = this.getNotebookSpecs().publicNetwork;
    return value >= 1000 ? `${value / 1000} GB/s` : `${value} MB/s`;
  }


  onSelectOpenedChange(type: "env" | "version", opened: boolean) {
    if (type === "env") {
      this.selectEnvOpened = opened;
    } else if (type === "version") {
      this.selectVersionOpened = opened;
    }

    setTimeout(() => feather.replace(), 0);
  }


   //****************************** ui interactions ********************************
  openSnackBarWithAction(
    msg: string,
    action: string,
    type: "success" | "error"
  ) {
    this.snackbarService.openSnackBarWithAction(msg, action, type);
  }


  //***********************quiskit tutorials ******************************
/*   private shouldAttachQiskitTutorials(): boolean {
    return (
      this.environment?.trim().toLowerCase() ===
        QISKIT_TUTORIALS_FRAMEWORK_ID.trim().toLowerCase() &&
      this.version?.trim() === QISKIT_TUTORIALS_FRAMEWORK_VERSION.trim()
    );
  } */
 private shouldAttachQiskitTutorials(): boolean {
  const result =
    this.environment?.trim().toLowerCase() ===
      QISKIT_TUTORIALS_FRAMEWORK_ID.trim().toLowerCase() &&
    this.version?.trim() === QISKIT_TUTORIALS_FRAMEWORK_VERSION.trim();

  console.log("Qiskit tutorials check", {
    environment: this.environment,
    version: this.version,
    expectedEnvironment: QISKIT_TUTORIALS_FRAMEWORK_ID,
    expectedVersion: QISKIT_TUTORIALS_FRAMEWORK_VERSION,
    result
  });

  return result;
}

  private buildNotebookVolumes(): NotebookCreateRequest["volumes"] | undefined {
  if (this.shouldAttachQiskitTutorials()) {
    return [QISKIT_TUTORIALS_VOLUME];
  }

  return undefined;
}

isQiskitTutorialEnvironmentSelected(): boolean {
  return (
    this.environment?.trim().toLowerCase() ===
    QISKIT_TUTORIALS_FRAMEWORK_ID.trim().toLowerCase()
  );
}

isQiskitTutorialVersionSelected(): boolean {
  return (
    this.isQiskitTutorialEnvironmentSelected() &&
    this.version?.trim() === QISKIT_TUTORIALS_FRAMEWORK_VERSION.trim()
  );
}



}
